












































































import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType,
    NewsPageDataType,
    componentDataType
} from "../types";
import {
    HOST,
    API_URL
} from "../global";
import {
    FETCH_NEWS_DATA,
    FETCH_PAGE_BY_ID,
    FETCH_CHILDREN,
    FETCH_BLOG_POSTS
} from "../store/actions.names";
import {
    SET_NEWS_CURRENT_PAGE,
    SET_NEWS_DATA,
    CURRENT_PAGE_ERROR,
    SET_NEWS_PARENT_PAGE
} from "../store/mutations.names";
import axios from "axios";
import {
    TimelineMax,
    TweenLite,
    Power1,
    Expo,
    Power2,
    TweenMax,
    Power4
} from "gsap";
import NewsSlider from "../components/NewsSlider.vue";
import NewsTab from "../components/NewsTab.vue";
import NewsAndUpdatePost from "../components/NewsAndUpdatePost.vue";


@Component({
    name: "NewsAndUpdateCategory",
    components: {
        NewsTab,
        NewsAndUpdatePost,
    }
})
export default class NewsAndUpdateCategory extends Vue {
    @Getter("newsData") public newsData!: NewsPageDataType[];
    @Prop() public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    @Action(FETCH_PAGE_BY_ID)[FETCH_PAGE_BY_ID]: any;
    @Action(FETCH_CHILDREN)[FETCH_CHILDREN]: any;
    @Action(FETCH_BLOG_POSTS)[FETCH_BLOG_POSTS]: any;
    @Mutation(SET_NEWS_CURRENT_PAGE) public[SET_NEWS_CURRENT_PAGE]: any;
    public HOST: string = HOST;
    public limit: number = 20;
    public offset: number = 0;
    public parent: pageDataType | null = null;
    public siblings: pageDataType[] | null = null;
    public count: number = 0;
    public posts: pageDataType[] = [];
     public smbanneranim(): void {
         const {
            imgoverlay
        } = this.$refs;
        TweenLite.delayedCall(2, overlay);

        function overlay() {
            TweenMax.to(imgoverlay, 0.3, {
                opacity: 0.6,
                ease: Power4.easeOut
            });
        }

        var smbanneranim = new TimelineMax({});

        smbanneranim
            .to(imgoverlay, 0.01, {
                opacity: 0
            })

            .staggerFrom(
                ".smbanner-container img",
                1, {
                    delay: 1.5,
                    autoAlpha: 0,
                    scale: 0.9,
                    ease: Power2.easeOut,
                    clearProps: "all"
                },
                 0.05,'-=.5'
            )

            .staggerFrom(
                ".smbanner-text h1",
                0.6, {
                   autoAlpha: 0,
                    yPercent: 40,
                    ease: Power2.easeInOut,
                    clearProps: "all"
                },
                0.02,'-=.5'
            )
            .staggerFrom(
                ".smbanner-text .sm-title",
                0.6, {
                    autoAlpha: 0,
                    yPercent: 40,
                    ease: Power2.easeInOut,
                    clearProps: "all"
                },
                 0.3,'-=.5'
            );
    }

    public setFromQuery() {
        // console.log(this.$route);
        if (this.$route.query.page) {
            let mod = (this as any).$route.query.page - 1;
            this.offset = this.limit * mod;
        } else {
            (this as any).page = 1;
        }
    }

    get params(): any {
        return {
            child_of: this.pageData.id,
            limit: this.limit,
            offset: this.offset,
            fields: "*"
        };
    }

    @Watch("params", {
        immediate: true,
        deep: true
    })
    handleParamChanges(val: any, oldVal: any) {
        if (val && val.child_of) {
            this.fetchData(val);
        }
    }

    public fetchData(params = this.params) {
        this[FETCH_BLOG_POSTS](params).then((data: any) => {
            this.posts = data.items;
            this.count = Math.max(0, data.meta.total_count / this.limit);
        });
    }

    public mounted() {
        this.setFromQuery();
        this[FETCH_PAGE_BY_ID]({
            id: (this as any).pageData.meta.parent.id
        }).then((val: any) => {
            this.parent = val;
        });
        this[FETCH_CHILDREN]((this as any).pageData.meta.parent.id).then((val: any) => {
            //console.log(val);
            this.siblings = val.items;
        });
        // this.smbanneranim();
    }
}
